import { AgentTypesType } from '../utils/constants/agent-types';
import {
  AppPath,
  CreditPath,
  DashboardPath,
  GamePath,
  ManageMemberPath,
  MarketingPath,
  PromotionPath,
  ReportsPath,
  SettingPaths,
  LinePath,
  LogPaths,
  InvoicePaths,
  SupportAdminPaths,
  MemberOutstanding,
  SmsPaths,
  ManageSagePath,
  ProfilePath,
  StockSports,
  StockESports,
  StockLotto,
  InMemoryPath,
  GameTransactionPath,
} from '../utils/constants/paths';
import { UserRolesType } from '../utils/constants/user-roles';

export const Sbo1x2 = 'Odd/Even,1X2,First Half 1x2,First Half O/U,First Half O/E,Asian 1X2';
export const SboOverUnder = 'Handicap,First Half Hdp,Over/Under,First Half O/U';

export const sidebarMenu: SidebarItem[] = [
  {
    type: 'router',
    name: 'PARTNERSHIP_SUMMARY',
    allowRoles: ['Superadmin', 'Partner'],
    autosystem: false,
    link: ['', AppPath.partner],
    iconClass: 'bi bi-pie-chart',
  },
  /** Header ------------- เเผงควบคุม  */
  {
    type: 'header',
    prefixName: '1. ',
    name: 'PROFILE',
    allowRoles: ['Superadmin', 'Admin', 'Operator', 'Company'],
  },
  {
    type: 'router',
    name: 'DETAILS',
    allowRoles: ['Superadmin', 'Admin', 'Operator', 'Partner', 'Company'],
    autosystem: false,
    link: ['', AppPath.dashboard, DashboardPath.summary, 'v2'],
    iconClass: 'bi bi-person',
  },
  {
    type: 'router',
    name: 'LOGIN_HISTORY',
    allowRoles: ['Superadmin', 'Admin', 'Operator', 'Partner', 'Company'],
    autosystem: false,
    link: ['', AppPath.profile, ProfilePath.login],
    iconClass: 'bi bi-clock-history',
  },
  {
    type: 'router',
    name: 'DEVELOPER',
    allowRoles: ['Superadmin', 'Admin', 'Operator'],
    autosystem: false,
    link: ['', AppPath.Developer],
    iconClass: 'bi bi-code-slash',
  },
  // {
  //   type: 'router', name: 'HELP', allowRoles: ['Superadmin', 'Admin', 'Operator'], autosystem: false, link: ['', AppPath.helpUser], imageSrc: 'assets/icons/help.gif',
  // },
  {
    type: 'router',
    name: 'INVOICE_WL',
    allowRoles: ['Superadmin', 'Admin', 'Operator'],
    autosystem: false,
    link: ['', AppPath.invoices],
    iconClass: 'bi bi-receipt',
  },
  /** Header ------------- จัดการสมาชิก  */
  {
    type: 'header',
    prefixName: '2. ',
    name: 'MANAGE_USERS',
    allowRoles: [
      'Superadmin',
      'Admin',
      'Operator',
      'Partner',
      'Company',
      'MemberManagement',
      'MemberManagementView',
      'Deposit',
      'Withdraw',
    ],
  },
  {
    type: 'menu',
    name: 'AGENT',
    iconClass: 'bi bi-diagram-3',
    menuList: [],
    allowRoles: ['Superadmin', 'Admin', 'Operator', 'Partner', 'Company'],
    allowAgents: ['Shareholder', 'Senior Agent', 'Master Agent', 'Agent'],
  },
  {
    type: 'menu',
    name: 'MANAGE_MEMBERS',
    iconClass: 'bi bi-people',
    menuList: [
      {
        name: 'CREATE_MEMBER',
        link: ['', AppPath.manageMember, 'cu', 'create'],
        spRoles: ['Member Password'],
      },
      {
        name: 'ALL_MEMBERS',
        link: ['', AppPath.manageMember, ManageMemberPath.all],
        spRoles: ['Member Password'],
      },
      {
        name: 'COPY_GAME_SETTINGS',
        link: ['', AppPath.manageMember, 'clone-setting'],
        spRoles: ['Member Password'],
      },
      // {
      //   name: 'ตั้งค่าสร้างสมาชิก', link: ['', AppPath.settings, SettingPaths.Member],
      //   allowRoles: ['Superadmin', 'Admin', 'Operator'],
      // },
    ],
    allowRoles: [
      'Superadmin',
      'Admin',
      'Operator',
      'MemberManagement',
      'MemberManagementView',
      'Deposit',
      'Withdraw',
    ],
    spRoles: ['Member Password'],
  },
  // {
  //   type: 'header',
  //   prefixName: '3. ',
  //   name: 'MANAGE_WEBPAGE',
  //   allowRoles: ['Superadmin', 'Admin'],
  // },
  // {
  //   type: 'router',
  //   name: 'SETTING_WEB',
  //   allowRoles: ['Superadmin', 'Admin'],
  //   autosystem: false,
  //   link: ['', AppPath.settingAgentFE],
  //   imageSrc: 'assets/icons/setting-web.png',
  // },

  /*
   Header ---------- Outstanding Game
  */
  {
    type: 'header',
    prefixName: '3. ',
    name: 'Stock Sports',
    allowRoles: ['Superadmin', 'Admin', 'Operator'],
  },
  {
    type: 'menu',
    name: 'Sbobet Stock',
    allowRoles: ['Superadmin', 'Admin', 'Operator'],
    autosystem: false,
    iconClass: 'bi bi-trophy',
    menuList: [
      {
        name: 'PLAY_HISTORY',
        autosystem: false,
        link: ['', AppPath.stockSports, StockSports.playList, StockSports.SBO],
      },
      {
        name: 'Parlay',
        autosystem: false,
        link: ['', AppPath.stockSports, StockSports.mixParlay, StockSports.SBO],
      },
      {
        name: 'HANDICAP_AND_OVER_UNDER',
        autosystem: false,
        link: [
          '',
          AppPath.stockSports,
          StockSports.overUnder,
          'handicap and over under',
          StockSports.SBO,
          SboOverUnder,
        ],
      },
      {
        name: 'ODD_EVEN_AND_1X2',
        autosystem: false,
        link: [
          '',
          AppPath.stockSports,
          StockSports.x12,
          'odd even and 1X2',
          StockSports.SBO,
          Sbo1x2,
        ],
      },
      {
        name: 'OUTSTANDING_BET',
        autosystem: false,
        link: ['', AppPath.stockSports, StockSports.allRunning, StockSports.SBO],
      },
    ],
  },
  {
    type: 'menu',
    name: 'Sbobet x AMB Stock',
    allowRoles: ['Superadmin', 'Admin', 'Operator'],
    autosystem: false,
    iconClass: 'bi bi-trophy-fill',
    menuList: [
      {
        name: 'PLAY_HISTORY',
        autosystem: false,
        link: ['', AppPath.stockSports, StockSports.playList, StockSports.SBOxAMB],
      },
      {
        name: 'Parlay',
        autosystem: false,
        link: ['', AppPath.stockSports, StockSports.mixParlay, StockSports.SBOxAMB],
      },
      {
        name: 'HANDICAP_AND_OVER_UNDER',
        autosystem: false,
        link: [
          '',
          AppPath.stockSports,
          StockSports.overUnder,
          'handicap and over under',
          StockSports.SBOxAMB,
          SboOverUnder,
        ],
      },
      {
        name: 'ODD_EVEN_AND_1X2',
        autosystem: false,
        link: [
          '',
          AppPath.stockSports,
          StockSports.x12,
          'odd even and 1X2',
          StockSports.SBOxAMB,
          Sbo1x2,
        ],
      },
      {
        name: 'OUTSTANDING_BET',
        autosystem: false,
        link: ['', AppPath.stockSports, StockSports.allRunning, StockSports.SBOxAMB],
      },
    ],
  },
  {
    type: 'menu',
    name: 'Askmebet Stock',
    allowRoles: ['Superadmin', 'Admin', 'Operator'],
    autosystem: false,
    iconClass: 'bi bi-flag',
    menuList: [
      {
        name: 'PLAY_HISTORY',
        autosystem: false,
        link: ['', AppPath.stockSports, StockSports.playList, StockSports.AMB],
      },
      {
        name: 'Parlay',
        autosystem: false,
        link: ['', AppPath.stockSports, StockSports.mixParlay, StockSports.AMB],
      },
      {
        name: 'HANDICAP_AND_OVER_UNDER',
        autosystem: false,
        link: [
          '',
          AppPath.stockSports,
          StockSports.overUnder,
          'handicap and over under',
          StockSports.AMB,
          'hdp,hdp1st,ou,ou1st',
        ],
      },
      {
        name: 'ODD_EVEN_AND_1X2',
        autosystem: false,
        link: [
          '',
          AppPath.stockSports,
          StockSports.x12,
          'odd even and 1X2',
          StockSports.AMB,
          'x121st,x12,oe,oe1st',
        ],
      },
      {
        name: 'OUTSTANDING_BET',
        autosystem: false,
        link: ['', AppPath.stockSports, StockSports.allRunning, StockSports.AMB],
      },
    ],
  },
  {
    type: 'menu',
    name: 'SABA Stock',
    allowRoles: ['Superadmin', 'Admin', 'Operator'],
    autosystem: false,
    iconClass: 'bi bi-award',
    menuList: [
      {
        name: 'PLAY_HISTORY',
        autosystem: false,
        link: ['', AppPath.stockSports, StockSports.playList, StockSports.SABA],
      },
      {
        name: 'Parlay',
        autosystem: false,
        link: ['', AppPath.stockSports, StockSports.mixParlay, StockSports.SABA],
      },
      {
        name: 'HANDICAP_AND_OVER_UNDER',
        autosystem: false,
        link: ['', AppPath.stockSports, StockSports.overUnder, StockSports.SABA],
      },
      {
        name: 'ODD_EVEN_AND_1X2',
        autosystem: false,
        link: ['', AppPath.stockSports, StockSports.x12, StockSports.SABA],
      },
      {
        name: 'OUTSTANDING_BET',
        autosystem: false,
        link: ['', AppPath.stockSports, StockSports.allRunning, StockSports.SABA],
      },
    ],
  },
  {
    type: 'menu',
    name: 'TFGaming Stock',
    allowRoles: ['Superadmin', 'Admin', 'Operator'],
    autosystem: false,
    iconClass: 'bi bi-controller',
    menuList: [
      {
        name: 'PLAY_HISTORY',
        autosystem: false,
        link: ['', AppPath.stockESports, StockESports.playList],
      },
      {
        name: 'COMBO',
        autosystem: false,
        link: ['', AppPath.stockESports, StockESports.Combo],
      },
      {
        name: 'OUTSTANDING_BET',
        autosystem: false,
        link: ['', AppPath.stockESports, StockESports.allRunning],
      },
    ],
  },
  {
    type: 'header',
    prefixName: '4. ',
    name: 'Stock Lotto',
    allowRoles: ['Superadmin', 'Admin', 'Operator'],
  },
  {
    type: 'menu',
    name: 'SuperLot999 Stock',
    allowRoles: ['Superadmin', 'Admin', 'Operator'],
    autosystem: false,
    iconClass: 'bi bi-ticket-perforated',
    menuList: [
      {
        name: 'ADJUST_INTAKE_SETTINGS',
        autosystem: false,
        link: ['', AppPath.stockLotto, StockLotto.settingReceiveSuperlot],
      },
      {
        name: 'CANCEL_BET_LOTTO',
        autosystem: false,
        link: ['', AppPath.stockLotto, StockLotto.cancelbetSuperlot],
      },
    ],
  },
  {
    type: 'menu',
    name: 'LottoGame Stock',
    allowRoles: ['Superadmin', 'Admin', 'Operator'],
    autosystem: false,
    iconClass: 'bi bi-dice-5',
    menuList: [
      {
        name: 'PLAY_HISTORY',
        autosystem: false,
        link: ['', AppPath.stockLotto, ''],
      },
    ],
  },
  /**
   * Header ------------- รายงาน
   */
  {
    type: 'header',
    prefixName: '5. ',
    name: 'REPORT',
    allowRoles: ['Superadmin', 'Admin', 'Operator', 'Report'],
  },
  {
    type: 'router',
    name: 'WL_ACCOUNT',
    allowRoles: ['Superadmin', 'Admin', 'Operator', 'Report'],
    autosystem: false,
    link: ['', AppPath.reports, ReportsPath.WL_AccoutSimple],
    iconClass: 'bi bi-bar-chart-line',
  },
  {
    type: 'router',
    name: 'WL_MEMBER_ONLY',
    allowRoles: ['Superadmin', 'Admin'],
    autosystem: false,
    link: ['', AppPath.reports, ReportsPath.WL_MemberOnly],
    iconClass: 'bi bi-bar-chart-line',
  },
  {
    type: 'router',
    name: 'WL_MEMBER_AGENT_DOWNLINE',
    allowRoles: ['Superadmin', 'Admin'],
    autosystem: false,
    link: ['', AppPath.reports, ReportsPath.WL_AgentDownline],
    iconClass: 'bi bi-bar-chart-line',
  },
  {
    type: 'router',
    name: 'WL_MEMBER_AGENT',
    allowRoles: ['Superadmin', 'Admin', 'Operator', 'Report'],
    autosystem: false,
    link: ['', AppPath.reports, ReportsPath.WL_Member],
    iconClass: 'bi bi-bar-chart-line',
  },
  {
    type: 'router',
    name: 'WL_PROVIDER',
    allowRoles: ['Superadmin', 'Admin', 'Operator', 'Report'],
    autosystem: false,
    link: ['', AppPath.reports, ReportsPath.WL_Provider],
    iconClass: 'bi bi-bar-chart-line',
  },
  {
    type: 'router',
    name: 'WL_PROVIDER_TYPE',
    allowRoles: ['Superadmin', 'Admin', 'Operator', 'Report'],
    autosystem: false,
    link: ['', AppPath.reports, ReportsPath.WL_GameType],
    iconClass: 'bi bi-bar-chart-line',
  },

  /**
   * Header ------------- จัดการระบบ
   * Superadmin, Admin, Operator
   */
  {
    type: 'header',
    name: 'MANAGE_SYSTEM',
    allowRoles: ['Superadmin', 'Admin'],
  },
  {
    type: 'menu',
    name: 'GAMES_MENU',
    iconClass: 'bi bi-grid-3x3-gap',
    allowRoles: ['Superadmin', 'Admin'],
    spRoles: ['Admin Support'],
    menuList: [
      {
        name: 'GAMES_SYSTEM',
        link: ['', AppPath.games, GamePath.play],
        allowRoles: ['Superadmin', 'Admin'],
        spRoles: ['Admin Support'],
      },
      {
        name: 'GAMES CALLBACK URL',
        link: ['', AppPath.games, GamePath.callback],
        allowRoles: ['Superadmin', 'Admin'],
        spRoles: ['Admin Support'],
      },
    ],
  },
  {
    type: 'menu',
    name: 'IN MEMORY DATA',
    iconClass: 'bi bi-memory',
    allowRoles: ['Superadmin', 'Admin'],
    spRoles: ['Admin Support'],
    menuList: [
      {
        name: 'MEMBERS',
        link: ['', AppPath.inMemory, InMemoryPath.members],
        allowRoles: ['Superadmin', 'Admin'],
        spRoles: ['Admin Support'],
      },
      {
        name: 'GAME SESSION',
        link: ['', AppPath.inMemory, InMemoryPath.gameSession],
        allowRoles: ['Superadmin', 'Admin'],
        spRoles: ['Admin Support'],
      },
      {
        name: 'WINLOSE DETAIL',
        link: ['', AppPath.inMemory, InMemoryPath.winloseDetail],
        allowRoles: ['Superadmin', 'Admin'],
        spRoles: ['Admin Support'],
      },
    ],
  },
  {
    type: 'router',
    name: 'SETTING_SYSTEM',
    link: ['', AppPath.settings, SettingPaths.All],
    iconClass: 'bi bi-gear',
    autosystem: false,
    allowRoles: ['Superadmin', 'Admin'],
  },
  {
    type: 'router',
    name: 'CALLBACK RETRY',
    link: ['', AppPath.callbackRetry],
    iconClass: 'bi bi-arrow-repeat',
    autosystem: false,
    allowRoles: ['Superadmin', 'Admin'],
  },

  /**
   * Header ------------- Monitor
   * Superadmin
   */
  {
    type: 'header',
    // -- รวมหน้า monitor ทั้ง 4 หน้าไว้ใต้หัวข้อนี้ แยกออกจาก "จัดการระบบ"
    // -- ให้เห็นเฉพาะ Superadmin เหมือนเมนูข้างใน (Admin จะได้ไม่เห็นหัวข้อว่าง)
    // -- ชื่อเมนูข้างใต้ไม่มีคำว่า MONITOR นำหน้าแล้ว เพราะหัวข้อบอกอยู่แล้ว (ชื่อหน้ายังเป็น Monitor ... ตามเดิม)
    name: 'Monitor',
    allowRoles: ['Superadmin'],
  },
  {
    type: 'router',
    name: 'JOB',
    link: ['', AppPath.monitorJob],
    iconClass: 'bi bi-terminal',
    autosystem: false,
    allowRoles: ['Superadmin'],
  },
  {
    type: 'router',
    name: 'OPEN API',
    link: ['', AppPath.monitorOpenApi],
    iconClass: 'bi bi-activity',
    autosystem: false,
    allowRoles: ['Superadmin'],
  },
  {
    type: 'router',
    // -- callback ขาออกที่ API ส่งไปหา agent developer (แยกจาก callback ขาเข้าจากค่ายเกม)
    name: 'CALLBACK AGENT',
    link: ['', AppPath.monitorCallback],
    iconClass: 'bi bi-send',
    autosystem: false,
    allowRoles: ['Superadmin'],
  },
  {
    type: 'router',
    // -- callback ขาเข้าที่ค่ายเกมยิงเข้ามา
    name: 'CALLBACK PROVIDER',
    link: ['', AppPath.monitorProviderCallback],
    iconClass: 'bi bi-inbox',
    autosystem: false,
    allowRoles: ['Superadmin'],
  },

  /**
   * Header ------------- Game transaction
   * Superadmin
   */
  {
    type: 'header',
    // -- หัวข้อใหม่ใต้กลุ่ม Monitor
    // -- ให้เห็นเฉพาะ Superadmin เหมือนกลุ่ม Monitor
    name: 'GAME TRANSACTION',
    allowRoles: ['Superadmin'],
  },
  {
    type: 'router',
    // -- หน้า W/L Running: บิลใน winlose_detail_* ที่ยัง running
    name: 'W/L RUNNING',
    link: ['', AppPath.gameTransaction, GameTransactionPath.winloseRunning],
    iconClass: 'bi bi-receipt',
    autosystem: false,
    allowRoles: ['Superadmin'],
  },
  {
    type: 'header',
    name: 'SYSTEM_USERS',
    allowRoles: ['Superadmin', 'Admin'],
  },
  {
    type: 'router',
    name: 'ADMIN_COMPANY',
    allowRoles: ['Superadmin', 'Admin'],
    autosystem: false,
    link: ['', AppPath.manageAdmin],
    iconClass: 'bi bi-person-gear',
  },
];

export interface SidebarItem {
  type: 'router' | 'header' | 'menu';
  prefixName?: string;
  name?: string;
  link?: string[];
  autosystem?: boolean;
  iconClass?: string;
  imageSrc?: string;
  iconName?: string;
  realTimeWork?: string;
  menuList?: SidebarMenuItem[];
  expanded?: boolean;
  allowRoles?: UserRolesType[];
  allowAgents?: AgentTypesType[];
  badgesName?: string;
  spRoles?: UserRolesType[];
  useConfigGameKlotto?: boolean;
  useConfigUserSage?: boolean;
}

export interface SidebarMenuItem {
  name?: string;
  badgesName?: string;
  autosystem?: boolean;
  link?: string[];
  allowRoles?: UserRolesType[];
  allowAgents?: AgentTypesType[];
  spRoles?: UserRolesType[];
}
